import { useState } from 'react';
import { Selection } from './LossTypes';
import { Loss } from '@typeRoots/common/loss';

export const useLossModals = () => {
  const [isYearModalVisible, setYearModalVisible] = useState(false);
  const [isChecklistModalVisible, setChecklistModalVisible] = useState(false);

  const handleModalYearSelect = (year: number, updateLoss: (loss: Partial<Loss>) => void) => {
    // Since `Loss` uses `lossYear` instead of `year`, update accordingly
    updateLoss({ lossYear: year });
    setYearModalVisible(false);
  };

  const handleModalClaimsSelect = (
    selectedClaims: Selection[],
    updateLoss: (loss: Partial<Loss>) => void,
  ) => {
    // Since `Loss` no longer has `claims`, map claims to relevant properties
    const updatedLoss = selectedClaims.reduce<Partial<Loss>>((acc, item) => {
      switch (item.subtype.name) {
        case 'Automobile Liability':
          acc.lossPaidAutoLiability = { amount: 0, currency: 'USD' }; // Placeholder example
          break;
        case 'Motor Truck Cargo':
          acc.lossPaidMotorTruckCargo = { amount: 0, currency: 'USD' }; // Placeholder example
          break;
        case 'General Liability':
          acc.lossPaidTruckingGeneralLiability = { amount: 0, currency: 'USD' }; // Placeholder example
          break;
        case 'Non-Trucking Liability':
          acc.lossPaidNonTruckingLiability = { amount: 0, currency: 'USD' }; // Placeholder example
          break;
        case 'Automobile Physical Damage':
          acc.lossPaidAutoPhysicalDamage = { amount: 0, currency: 'USD' }; // Placeholder example
          break;
        default:
          console.warn(`Unhandled claim type: ${item.subtype.name}`);
          break;
      }
      return acc;
    }, {});

    updateLoss(updatedLoss);
    setChecklistModalVisible(false);
  };

  return {
    isYearModalVisible,
    setYearModalVisible,
    isChecklistModalVisible,
    setChecklistModalVisible,
    handleModalYearSelect,
    handleModalClaimsSelect,
  };
};
